import React from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
  SafeAreaView,
} from "react-native";
import { globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const PrizeBreakUp = ({prizePoolPrice, prizePool}) => {
  return (
    <View
      style={{
        //paddingHorizontal: 10,
        paddingBottom: 10,
        marginTop: -16,
        width: Width.width,
        flex: 1,
        justifyContent: "flex-start",
      }}
    >
      <View style={styles.prizeHeader}>
        <FormTextLabel
          labelStyles={[globalFontStyle.appFontSubText, { color: Colors.bgWhite }]}
          label={"Prize Pool "}
        />
        <Text
          style={[
            globalFontStyle.appFontTitleRegular,
            { color: Colors.bgWhite },
          ]}
        >
            {prizePoolPrice}
        </Text>
      </View>
      <FlatList
        contentContainerStyle={{ paddingHorizontal: 20, paddingBottom: 20 }}
        //ListHeaderComponent={headerComponent}
        scrollEnabled
        data={prizePool}
        renderItem={(itemList, index) => {
          return (
            <View>
              <View style={styles.rowStyle}>
                <Text>{itemList?.item?.key}</Text>
                <Text>{itemList?.item?.value}</Text>
              </View>
              <View
                style={{ borderBottomWidth: 1, borderBottomColor: "#DBDBDB" }}
              />
            </View>
          );
        }}
        //onRefresh={PullToRefresh}
        //refreshing={loading}
        keyExtractor={(item, index) => index}
        showsVerticalScrollIndicator={false}
        //initialNumToRender={50}
      />
    </View>
  );
};

export default PrizeBreakUp;

const styles = StyleSheet.create({
  prizeHeader: {
    paddingVertical: 18,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    backgroundColor: Colors.black,
    marginBottom: 25,
  },
  rowStyle: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 10,
    paddingHorizontal: 4,
  },
});
